/* @flow weak */

const Reflux = require('reflux');

const VisualizationActions = require('../actions/VisualizationActions.jsx');

const VisualizationStore = Reflux.createStore({
  listenables: [VisualizationActions],

  domHeightLastValue: 0,

  visData: {
    mainRect: document.getElementById('uc-main-section') ? document.getElementById('uc-main-section').getBoundingClientRect() : {},
    previewRect: {},
    delayRender: false
  },

  getInitialState() {
    return this.visData;
  },

  init() {
    this.visData.previewRect = document.getElementById('uc-preview-section') ? document.getElementById('uc-preview-section').getBoundingClientRect() : {};
    window.addEventListener('scroll', this.updateClientRectangles);
    window.addEventListener('resize', this.updateClientRectangles);

    this.domHeightLastValue = document.getElementById('uc').getBoundingClientRect().height;

    window.setInterval(this.monitorDomHeight, 200);

    this.trigger(this.visData);
  },

  monitorDomHeight() {
    let domHeight = document.getElementById('uc').getBoundingClientRect().height;
    if (this.domHeightLastValue !== domHeight) {
      this.domHeightLastValue = domHeight;
      this.updateClientRectangles();

      this.trigger(this.visData);
    }
  },

  updateClientRectangles() {
    this.visData.mainRect = document.getElementById('uc-main-section') ? document.getElementById('uc-main-section').getBoundingClientRect() : {};
    this.visData.previewRect = document.getElementById('uc-preview-section') ? document.getElementById('uc-preview-section').getBoundingClientRect() : {};
    this.trigger(this.visData);
  },

  renderTimer: null,

  onDelayRenderSync() {
    if (this.renderTimer !== null) {
      clearTimeout(this.renderTimer);
    } else {
      this.visData.delayRender = true;
      this.trigger(this.visData);
    }

    this.renderTimer = setTimeout(() => {
      this.renderTimer = null;
      this.visData.delayRender = false;
      this.trigger(this.visData);
    }, 500);
  }
});

module.exports = VisualizationStore;


// WEBPACK FOOTER //
// ./src/base/scripts/stores/VisualizationStore.jsx